<template>
  <router-view />
</template>

<script>
import { fbappid, googleclientid } from '@/config';

export default {
  mounted() {
    window.fbAsyncInit = () => {
      window.FB.init({
        appId: fbappid,
        cookie: true,
        xfbml: true,
        version: 'v5.0'
      });
      window.FB.AppEvents.logPageView();
    };
    // eslint-disable-next-line func-names
    window.onLoadCallback = function () {
      const clientid = googleclientid;
      // eslint-disable-next-line no-undef
      window.gapi.load('auth2', () => {
        const auth2 = window.gapi.auth2.init({
          client_id: clientid,
          cookiepolicy: 'single_host_origin'
        });
        auth2.attachClickHandler(this.$refs.signinBtn, {}, (googleUser) => {
          this.$emit('done', googleUser);
        }, error => console.log(error));
      });
    };
  }
};
</script>
